export const ORGANIZATION_MEMBER_STATUS = {
    REQUESTED: 'REQUESTED',
    APPROVED: 'APPROVED',
}
